export const DEFAULT_THANK_YOU_PAGE_MESSAGE = '<p>Your donation was successfully processed.</p><p>You can help advance your impact by spreading the word about this campaign.</p>'

export const DONATION_THANK_YOU_MERGE_FIELDS = [
  { group: 'Donor', label: 'First name', value: 'donor.first_name', description: 'The first word of the donor’s billing name' },
  { group: 'Donor', label: 'Last name', value: 'donor.last_name', description: 'The remaining words of the donor’s billing name' },
  { group: 'Donor', label: 'Email', value: 'donor.email', description: 'The donor’s billing email address' }
]
